import axios from "axios";
import { getAPICall, postAPICall } from "./baseClient";

export const getUserDetails = async (payload: { id: string | undefined }) => {
  const { data: response } = await getAPICall(
    `/admin/get-assessment-response/${payload.id}`
  );
  return response;
};
